import React from 'react'
import { Controller } from 'react-hook-form'
import { InputText, Select } from '@telavita-core/react-design-kit'

import { RelationshipEnum } from 'models/Enums'

import * as S from './styles'

function generateOptions() {
  return Object.keys(RelationshipEnum).map((relationship) => {
    return {
      id: relationship,
      label: RelationshipEnum[relationship] as string
    }
  })
}

function formatPhone(value: string) {
  const onlyNumbers = value.replace(/[^0-9]/g, '')
  let formattedValue = onlyNumbers

  if (onlyNumbers.length > 2) {
    formattedValue = onlyNumbers.replace(/^(\d{2})(\d*)$/, '$1 $2')
  }

  return formattedValue
}

export const FamilyContactInputFields = ({ control, setFocus }): JSX.Element => {
  return (
    <S.Container>
      <Controller
        name='familyContact.fullName'
        control={control}
        render={({ field, fieldState: { error } }) => {
          return(
            <InputText
              {...field}
              handleClearSearchField={() => {
                field.onChange({ target: { value: '' }})
                setFocus('familyContact.fullName')
              }}
              floatingLabel='Nome completo do familiar *'
              helperMessageVariant='error'    
              helperMessage={error?.message}
              hasError={Boolean(error?.message)}
            />
          )
        }}
      />

      <Controller
        name='familyContact.relationship'
        control={control}
        render={({ field, fieldState: { error } }) => {
          return(
            <Select 
              {...field}
              label=''
              placeholder='Grau de parentesco *'
              customClassName='contactDropdown'
              onSelect={(value) => field.onChange(value.id)}
              options={generateOptions()}
              selected={generateOptions().find((option) => option.id === field.value)}
              hasError={Boolean(error?.message)}
              messageError={error?.message}
            />
          )
        }}
      />

      <Controller
        name='familyContact.phone'
        control={control}
        render={({ field, fieldState: { error } }) => {
          return(
            <InputText
              {...field}
              handleClearSearchField={() => {
                field.onChange({ target: { value: '' }})
                setFocus('familyContact.phone')
              }}
              floatingLabel='Número de telefone do familiar *'
              helperMessageVariant='error'
              helperMessage={error?.message}
              maxLength={12}
              onChange={(e) => field.onChange(formatPhone(e.target.value))}
              hasError={Boolean(error?.message)}
            />
          )
        }}
      /> 
    </S.Container>
  )
}